import React, { useEffect, useRef } from 'react';
import { observer } from 'mobx-react';
import { ClippedContainer } from './ClippedContainer';
import stores from 'cd-eft/models/Stores';
import { ClippedContainerVM } from './ClippedContainerVM';

const ClippedDEMComponent = (props: any) => {
  const setStore = stores.AppStore.surveyEngineeringStore;
  const vm = useRef(new ClippedContainerVM(props)).current;
  useEffect(() => {
    vm.importDEMHandler()
    setStore.currentTab = "Clipped DEM"
  }, []);

  return (
    <div>
      <ClippedContainer />
    </div>
  );
};

export const ClippedDEM = observer(ClippedDEMComponent);
